"use client";

import Script from "next/script";
import { config } from "@/lib/config";

const GA_MEASUREMENT_ID = "G-E3RPD6G0M9";

export function GoogleAnalytics() {
  // Only load Google Analytics in production
  if (!config.isProduction) {
    return null;
  }

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GA_MEASUREMENT_ID}');
        `}
      </Script>
    </>
  );
}
